module.exports = __webpack_public_path__ + "us.fa563627.svg";